import { lazy, useMemo, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useUser } from "@clerk/react";
import { useMediaQuery } from "react-responsive";
import { Fragment } from "react/jsx-runtime";

import { resolveRole } from "@/utils/roles";
import { DesktopRoutes } from "./desktop-routes";
import { MobileRoutes } from "./mobile-routes";
import { DocsRoutes } from "./docs-routes";


const RouteController = () => {
  const { user } = useUser();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [currentRole, setCurrentRole] = useState("admin");

  return (
    <Routes>
      <Route path="/sso-callback" element={<Navigate to="/" replace />} />

      {DocsRoutes()}

      {isMobile && <Fragment>{MobileRoutes()}</Fragment>}

      {!isMobile && <Fragment>{DesktopRoutes({ isAdmin: resolveRole(user) === "admin" })}</Fragment>}

      <Route path="/*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default RouteController;
